function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

export default [
  {
    path: '/app/mobile',
    component: loadView('mobile/mobile'),
    children: [
      {
        path: 'transactions',
        name: 'mobile_transactions_page',
        component: loadView('inside/pages/transactions'),
        props: true,
        children: [
          {
            path: 'calendar',
            name: 'mobile_calendar', // don't rename those, some logic is linked to those names
            component: loadView('inside/pages/calendar'),
            props: true
          },
          {
            path: 'list',
            name: 'mobile_list', // don't rename those, some logic is linked to those names
            component: loadView('inside/pages/list'),
            props: true
          }
        ]
      },
      {
        path: 'accounts',
        name: 'mobile_accounts_page',
        component: loadView('mobile/pages/accounts')
      },
      {
        path: 'envelopes',
        name: 'mobile_envelopes_page',
        component: loadView('mobile/pages/envelopes')
      },
      {
        path: 'reports',
        name: 'mobile_reports_page',
        component: loadView('inside/pages/reports'),
        children: [
          {
            path: 'compare_periods',
            name: 'mobile_reports_periods_page', // don't rename those, some logic is linked to those names
            component: loadView('inside/pages/reports/compare_periods')
          },
          {
            path: 'net_worth',
            name: 'mobile_reports_networth_page',
            component: loadView('inside/pages/reports/net_worth')
          }
        ]
      },
      {
        path: 'settings',
        name: 'mobile_settings_page',
        component: loadView('inside/pages/settings'),
        children: [
          {
            path: 'general',
            name: 'mobile_general_settings_page',
            component: loadView('inside/pages/settings/general')
          },
          {
            path: 'payment',
            name: 'mobile_payment_page',
            component: loadView('inside/pages/settings/payment')
          },
          {
            path: 'subscription',
            name: 'mobile_subscription_page',
            component: loadView('inside/pages/settings/subscription')
          },
          {
            path: 'changelog',
            name: 'mobile_changelog_page',
            component: loadView('guest/changelog')
          }
        ]
      }
    ]
  }
]
